export const resolveCreateBookingPath = (editPathname: string, requestedCreateBookingPath?: string) => {
  if (editPathname.startsWith('/ApptSysPublicWeb/v1')) {
    return '/ApptSysPublicWeb/v1';
  }

  return requestedCreateBookingPath === '/ApptSysPublicWeb/internal-booking'
    ? '/ApptSysPublicWeb/internal-booking'
    : '/ApptSysPublicWeb';
};
